export const environment = {
  production: true,
  stage: 'prod',
  apiGatewayUrl: 'https://lambdas.mobydyg.com/',
  apiKey: 'RnNWU0U1FUypwP3LxqbMWMQ5QzYaVXx46XiiquSGG3qj4oa5p804NTiqLzdk69SMQNHtzYuh95IkTeWU3WMBTcCOFzo5rGyj8x1N',
  posBaseUrl: 'https://pos.mobydyg.com',
  analyticsBaseUrl: 'https://analytics.mobydyg.com',
  chatAppBaseUrl: 'https://conversation.mobydyg.com',
};
